import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { all_routes } from '../router/all_routes';
import Table from "../../core/common/dataTable/index";
import { apibaseurl } from '../../environment';
import useApi from '../../core/customhook/useApi';
import CollapseHeader from '../../core/common/collapse-header/collapse-header';

const Payslip = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // 1–12

    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [selectedYear, setSelectedYear] = useState(currentYear);

    const months = [
        { value: 1, label: "January" },
        { value: 2, label: "February" },
        { value: 3, label: "March" },
        { value: 4, label: "April" },
        { value: 5, label: "May" },
        { value: 6, label: "June" },
        { value: 7, label: "July" },
        { value: 8, label: "August" },
        { value: 9, label: "September" },
        { value: 10, label: "October" },
        { value: 11, label: "November" },
        { value: 12, label: "December" },
    ];
    const years = [
        currentYear - 1,
        currentYear,
        currentYear + 1,
    ];
    const columns = [
        {
            title: "Sr No.",
            render: (_: any, __: any, index: number) => index + 1,
        },
        {
            title: "Employee ID",
            dataIndex: "employee_id",
        },
        {
            title: "Employee Name",
            dataIndex: "employee_name",
        },

        {
            title: "Year",
            dataIndex: "year",
        },
        {
            title: "Month",
            dataIndex: "month",
        },
        {
            title: "Payslip",
            dataIndex: "file_path",
            render: (text: string) => (
                <a href={`${apibaseurl}/${text}`} target="_blank" rel="noreferrer">
                    View PDF
                </a>
            ),
        },
    ];
    const [data, setData] = useState<any[]>([]);

    const {
        data: pay_slip_data,
        loading: pay_slip_loading,
        error: pay_slip_error,
    } = useApi("/api/payslip", {
        method: "POST",
        payload: {
            month: selectedMonth,
            year: selectedYear,
        },
        autoCall: true,
        dependencies: [selectedMonth, selectedYear],
    });


    useEffect(() => {
        if (pay_slip_data?.success) {
            setData(pay_slip_data?.payslips)
        }
    })

    return (
        <>


            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Payslips</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Dashboard
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        All Payslips
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Payslip List</h5>

                            <div className="d-flex gap-2">
                                {/* Month Dropdown */}
                                <select
                                    className="form-select"
                                    value={selectedMonth}
                                    onChange={(e) => setSelectedMonth(Number(e.target.value))}
                                >
                                    {months.map((m) => (
                                        <option key={m.value} value={m.value}>
                                            {m.label}
                                        </option>
                                    ))}
                                </select>

                                {/* Year Dropdown */}
                                <select
                                    className="form-select"
                                    value={selectedYear}
                                    onChange={(e) => setSelectedYear(Number(e.target.value))}
                                >
                                    {years.map((year) => (
                                        <option key={year} value={year}>
                                            {year}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="card-body p-0">

                            <Table dataSource={data} columns={columns} Selection={false} />

                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
                    <p className="mb-0">© 2025 WeConnect. All rights reserved.</p>
                </div>
            </div>
            {/* /Page Wrapper */}

        </>

    )
}

export default Payslip
